// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Nav from "../navigation/Nav.res.js";
import * as Media from "../../primitives/Media.res.js";
import * as React from "react";
import * as Breakpoints from "../theme/Breakpoints.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  container: {
    "backgroundColor-kWkggS": "backgroundColor-x1srn7af",
    "transition-kmkexE": "transition-x1tia9vx",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "flex-kUk6DE": "flex-x98rzlu",
    "flexDirection-kXwgrk": "flexDirection-xdt5ytf",
    "minHeight-kAzted": "minHeight-x2lwn1j",
    "minWidth-k7Eaqz": "minWidth-xeuugli",
    "paddingLeft-kE3dHu": "paddingLeft-x1uhho1l",
    $$css: "wino-gc:src/resources/layout-and-structure/AppLayout.res.js:11"
  }
};
function containerStyleFromParams(navOpened) {
  let paddingLeft = navOpened ? Nav.openedSize : Nav.closedSize;
  return Stylex.props(styles.container, {
    paddingLeft: String(paddingLeft) + "px"
  });
}
function AppLayout(props) {
  let match = Nav.Context.getReducer();
  let navState = match[0];
  let tabletOrLargerScreen = Media.use(Breakpoints.medium);
  let newrecord = {
    ...containerStyleFromParams(navState.opened)
  };
  let newrecord$1 = {
    ...{
      className: "display-x78zum5 flex-x98rzlu flexDirection-xdt5ytf minHeight-x2lwn1j position-x1n2onr6 width-xh8yej3 zIndex-x1vjfegm",
      "data-style-src": "wino-gc:src/resources/layout-and-structure/AppLayout.res.js:22"
    }
  };
  newrecord.children = [props.navBar, JsxRuntime.jsxs("div", (newrecord$1.children = [tabletOrLargerScreen ? props.alertBar : null, props.children], newrecord$1))];
  return JsxRuntime.jsx(Nav.Context.Provider.make, {
    value: [navState, match[1]],
    children: JsxRuntime.jsxs("div", newrecord)
  });
}
let make = React.memo(AppLayout);
export { make };
/* styles Not a pure module */